import URLConfig from "@Config/urls/url.config";
import { LinkItemProps } from "@Layouts/sidebar/AppSidebar";

const URL = URLConfig.ADMIN.INTEGRATION_SETTINGS.ATM_MENU;

const AtmMenuLink: Array<LinkItemProps> = [
  {
    name: "States",
    link: URL.STATES,
    level: 3,
  },
  {
    name: "Screen",
    link: URL.SCREEN,
    level: 3,
  },
  {
    name: "Parameter Values",
    link: URL.PARAMETER_VALUES,
    level: 3,
  },
  {
    name: "Offered Services",
    link: URL.OFFERED_SERVICES,
    level: 3,
  },
  {
    name: "Configured Services",
    link: URL.CONFIGURED_SERVICES,
    level: 3,
  },
  {
    name: "Reply Values",
    link: URL.REPLY_VALUES,
    level: 3,
  },


];

export default AtmMenuLink;
